export default "__VITE_ASSET__DbVuUs6L__"